import React from "react";

const Droprightarrow = (props) => {
  return (
    <svg
      {...props}
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="100%"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M192 128l128 128-128 128z"></path>
    </svg>
  );
};

export default Droprightarrow;
